module.exports = __webpack_public_path__ + "static/media/html5.5d6cd40c.png";